// CsvModal.tsx
import React from 'react';
import { Modal, Button } from 'react-bootstrap';
import BaseModal from './BaseModal';
import { FieldDescriptor } from '../../types/modal/FieldDescriptor';

export interface CsvModalProps<T> {
  show: boolean;
  item?: T;
  fields?: FieldDescriptor<T>[];
  onClose: () => void;
  onConfirm: () => void;
  children?: React.ReactNode; // モーダル内で自由にコンテンツを指定したい場合
  modalTitle?: string;
  saveButtonLabel?: string; // 保存ボタンのラベル（デフォルトは "保存"）
}

const CsvModal = <T,>({
  show,
  item,
  fields,
  onClose,
  onConfirm,
  children,
  modalTitle = '以下の内容をCSV形式で出力しますか？',
  saveButtonLabel = '保存',
}: CsvModalProps<T>) => {
  const body =
    item && fields && fields.length > 0 ? (
      <div className="mx-auto w-75 d-grid gap-3">
        {fields.map((f) => (
          <div key={String(f.key)}>
            {f.label}： {String(item[f.key])}
          </div>
        ))}
      </div>
    ) : (
      children
    );

  return (
    <BaseModal show={show} onHide={onClose}>
      {/* ヘッダー（ニュートラル：色は付けず中央寄せ） */}
      <Modal.Header className="justify-content-center border-0">
        <Modal.Title as="h5" className="w-100 text-center m-0">
          {modalTitle}
        </Modal.Title>
      </Modal.Header>

      {/* 本文 */}
      <Modal.Body className="justify-content-center">{body}</Modal.Body>

      {/* フッター */}
      <Modal.Footer className="justify-content-center border-0">
        <Button variant="secondary" onClick={onClose}>
          キャンセル
        </Button>
        <Button variant="primary" onClick={onConfirm}>
          {saveButtonLabel}
        </Button>
      </Modal.Footer>
    </BaseModal>
  );
};

export default CsvModal;
